import { type DriveFile } from '@/shared/DriveTypes';
import { rem } from 'polished';
import Title from '~/elements/Title/Title';
import { AddNewContainer } from '../AddMenu/AddNewContainer';
import * as pageStyles from './Page.css';

export const WelcomePage = ({ wiki, files }: { wiki: DriveFile; files: DriveFile[] }) => {
  return (
    <>
      <Title className={pageStyles.title} style={{ marginLeft: -1 }}>
        Getting started
      </Title>
      <div style={{ marginTop: rem(28) }}>
        👋 Welcome! This is your <b>{wiki.name}</b> wiki.
      </div>
      <div style={{ marginTop: rem(36) }}>
        <h4 style={{ marginBottom: rem(8), fontWeight: 700 }}>To get started:</h4>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          Add a page, folder, link or shortcut by clicking
          <AddNewContainer wiki={wiki} file={wiki} files={files} animation="right" />
        </div>
      </div>
    </>
  );
};
